module.exports = __webpack_public_path__ + "img/bannerimg01.f682c3c1.png";